import { IsDefined, IsNumber, IsString, Min } from 'class-validator';

export const SHADOW_TYPE_VALUES = ['none', 'drop'] as const;
export type ShadowType = (typeof SHADOW_TYPE_VALUES)[number];

export class ShadowSettingsDto {
  @IsDefined()
  @IsNumber()
  x!: number;

  @IsDefined()
  @IsNumber()
  y!: number;

  @IsDefined()
  @IsNumber()
  @Min(0)
  blur!: number;

  @IsDefined()
  @IsNumber()
  spread!: number;

  @IsDefined()
  @IsString() // Not a color reference string. Just a plain ol' hex string starting with #.
  color!: string;
}
